import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

function IDDialogLoadingInfo(props) {
  const { t } = useTranslation();
  const { modelLoading, isCapturing, loadingMessage } = props;
  return (
    (modelLoading || isCapturing) && (
        <div className="loading-overlay">
        <CircularProgress color="inherit" size={20} />
        {loadingMessage || (modelLoading ? t("Loading model...") : t('Capturing...'))}
      </div>
    )
  )
}

export default IDDialogLoadingInfo;